export default "__VITE_ASSET__DG5hQJb0__"